<template>
  <div class="barra-lateral-esquerdo">

    <figure @click="deslogar" class="figure-image">
      <div v-if="getDeslog" class="backGroundOrangeRed">
        <img src="/imgs/icons/power-white.svg" class="img" />
        <figcaption>Deslogado</figcaption>
      </div>
      <div v-else class="backgroundGreen">
        <img src="/imgs/icons/power-white.svg" class="img" />
        <figcaption>Logado</figcaption>
      </div>
    </figure>

    <figure @click="operatorRealtime()" class="figure-image">
      <div :class="{ 'bg-adv': getOperatorRealtime }">
        <img src="/imgs/icons/realtime-icon.svg" class="img" />
        <figcaption>Realtime</figcaption>
      </div>
    </figure>

    <figure @click="contacts()" class="figure-image">
      <div :class="{ 'bg-adv': getContacts }">
        <img src="/imgs/icons/address-book.svg" class="img" />
        <figcaption>Contatos</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" class="figure-image">
      <div v-if="getChannel() != ''" @click="hangup" class="backGroundOrangeRed">
        <img src="/imgs/icons/telephone-forward-white.svg" class="img" alt="" />
        <figcaption>Desligar</figcaption>
      </div>
      <div v-else @click="discar">
        <img src="/imgs/icons/telephone-forward-white.svg" class="img" alt="" />
        <figcaption>Discar</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" @click="pause" class="figure-image">
      <div v-if="getPause" :class="['backGroundOrange', { 'blink-red': isBlinking }]">
        <img src="/imgs/icons/pause-white.svg" class='img'>
        <figcaption>{{ time_pause_format }} <br> Pausado</figcaption>
      </div>
      <div v-else>
        <img src="/imgs/icons/pause-white.svg" class='img'>
        <figcaption>Pausar</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" @click="mute" class="figure-image">
      <div v-if="getMute" class="backGroundOrange">
        <img src="/imgs/icons/mute-white.svg" class="img" alt="" />
        <figcaption>Mudo</figcaption>
      </div>
      <div v-else>
        <img src="/imgs/icons/mute-white.svg" class="img" alt="" />
        <figcaption>Mute</figcaption>
      </div>
    </figure>

    <figure @click="agendamento" class="figure-image" style="display: none">
      <div class="">
        <img src="/imgs/icons/calendar-date-white.svg" class="img" />
        <figcaption>Agendamento</figcaption>
      </div>
    </figure>

    <div hidden>{{ loadUserData }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import clientData from "../../store/modules/spearhead";
import { connection } from "../../connetions/amiCon";
import Swal from "sweetalert2";
const parsedTelefone = process.env.MIX_TELEFONE === "true";

export default {
  data() {
    return {
      interval_pause: "",
      time_pause: "",
      time_pause_format: "00:00:00",
      debugDisc: false,
      total_in_queue: "",
      userQueues: [],
      queuePause: false,
      telefone: parsedTelefone,
      isBlinking: false,
      redFlag: false,
      ramal: user.getExtension(),
      hangupObj: {
        dados: [],
        uniqueid: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getDeslog",
      "getModalPause",
      "getMessages",
      "getOccurrences",
      "getShowHistory",
      "getCnpj",
      "getPause",
      "getMute",
      "getQueues",
      "getExtension",
      "getId",
      "getChannel",
      "getChamada",
      "allClients",
      "getShowSpearhead",
      "getProtocol",
      "getCallTime",
      "getPauseTime",
      "oneClient",
      "getShowBarRight",
      "getTotalMyQueue",
      "getTotalInQueue",
      "getContacts",
      "getCalendar",
      "getOperatorRealtime",
      "getShowBillingCampaign",
      "getStartCountdown",
      "getShowCommercialCampaign",
      "getShowImplantacaoCampaign",
      "getMotivoPause",
      "getModalCall"
    ]),
    loadUserData: function () {
      this.setExtension(user.getId());
      this.setQueues(user.getQueue());
      this.setId(user.getId());
    },
  },
  watch: {
    getPauseTime: function () {
      this.validateTimePause();
    },
    time_pause: function () {
      this.time_pause_format = moment
        .utc(this.time_pause * 1000)
        .format("HH:mm:ss");
    },
  },
  created() {
    this.setMessage();
    if (user.getQueue().length) {
      user.getQueue().map(el => this.userQueues.push({ queue: el, logged: false, paused: false }))
    }
    if (this.telefone) return;

    this.startOrOut();
  },
  methods: {
    ...mapActions([
      "selectPause",
      "sendPauseApi",
      "sendOperatorPauseApi",
      "setOccurrences",
      "setShowHistory",
      "setModalPause",
      "setModalSchedule",
      "settModalCall",
      "setMessage",
      "fetchOcurrences",
      "fetchPauses",
      "comeBack",
      "setDeslog",
      "startOrOut",
      "setMute",
      "setExtension",
      "setQueues",
      "setId",
      "getRealTime",
      "sendUnpause",
      "sendOperatorUnpause",
      "setChannel",
      "fetchClients",
      "fetchProtocol",
      "setShowSpearhead",
      "chooseClient",
      "chooseClientCnpj",
      "clearAllClients",
      "setCallTime",
      "setPauseTime",
      "saveProduct",
      "clearClient",
      "saveClient",
      "setShowBarRight",
      "checkTotalQUeues",
      "totalMyQueue",
      "setContacts",
      "chooseClientPhone",
      "setShowBillingCampaign",
      "setShowCommercialCampaign",
      "setShowImplantacaoCampaign",
      "setStartCampaign",
      "setDelDataConnectLine",
      "setCallData",
      'fetchStoreQueues',
      'setOperatorRealtime'
    ]),
    ...mapMutations(["setClient", "setMotivoPause"]),
    validateTimePause() {
      const audio = new Audio('/sounds/blinking-bell.mp3');
      if (this.interval_pause) {
        clearInterval(this.interval_pause);
        this.interval_pause = null;
      }
      if (this.audio_interval) {
        clearInterval(this.audio_interval);
        this.audio_interval = null;
      }

      // força conversão para segundos caso venha timestamp
      if (this.getPauseTime != 'null') {
        const now = Math.floor(Date.now() / 1000);
        this.time_pause = (this.getPauseTime > 36000)
          ? now - this.getPauseTime
          : this.getPauseTime;
      } else {
        this.time_pause = 0;
        return; // *** IMPORTANTE: Retornar se não houver pausa ativa ***
      }

      if (this.time_pause >= 0) {
        // Incrementa o contador a cada segundo
        this.interval_pause = setInterval(() => {
          this.time_pause++;

          if (this.break === "almoço" && this.time_pause === 5700) {
            audio.play();
            this.startBlinking();
            this.redFlag = true;
            this.audio_interval = setInterval(() => {
              if (this.redFlag) audio.play();
            }, 10000);
          }

          if (this.break === "café" && this.time_pause === 900) {
            audio.play();
            this.startBlinking();
            this.redFlag = true;
            this.audio_interval = setInterval(() => {
              if (this.redFlag) audio.play();
            }, 10000);
          }

          if (this.break === "toilet" && this.time_pause === 600) {
            audio.play();
            this.startBlinking();
            this.redFlag = true;
            this.audio_interval = setInterval(() => {
              if (this.redFlag) audio.play();
            }, 10000);
          }
        }, 1000);
      }
    },
    startBlinking() {
      this.isBlinking = true;
    },
    historicol() {
      if (!this.getDeslog && !this.getShowHistory) {
        this.setShowHistory();
        this.fetchOcurrences(this.getCnpj);
      }
    },
    discar() {
      if (!this.getModalCall) {
        if (user.getProfile() == 2) {
          if (!this.getDeslog) this.settModalCall();
        } else {
          this.settModalCall();
        }
      }
    },
    getTime() {
      var d = new Date();
      return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    },
    getPausedQueuesFromStatus(timeoutMs = 2500) {
      return new Promise((resolve) => {
        let resolved = false;
        const finish = (value) => {
          if (!resolved) {
            resolved = true;
            resolve(value);
          }
        };

        const timeoutId = setTimeout(() => {
          console.warn('[DEBUG PAUSE] Timeout aguardando QueueStatus callback.', {
            timeoutMs,
            socketConnected: !!connection?.connected
          });
          finish([]);
        }, timeoutMs);

        connection.emit("QueueStatus", { ramal: user.getExtension() }, (queues) => {
          clearTimeout(timeoutId);
          console.log('[DEBUG PAUSE] QueueStatus bruto para despausa:', queues);

          if (!Array.isArray(queues)) {
            console.warn('[DEBUG PAUSE] QueueStatus retornou formato inesperado:', queues);
            finish([]);
            return;
          }

          const pausedQueues = queues
            .filter((queue) => parseInt(queue.Paused, 10) === 1)
            .map((queue) => queue.Queue)
            .filter(Boolean);

          console.log('[DEBUG PAUSE] Filas pausadas detectadas pelo QueueStatus:', pausedQueues);
          finish(pausedQueues);
        });
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    emitQueueUnpause(queues) {
      console.log('[DEBUG PAUSE] Emitindo QueueUnPause para filas:', queues);
      queues.forEach((queue) => {
        console.log('[DEBUG PAUSE] QueueUnPause ->', {
          extension: user.getExtension(),
          queue
        });
        connection.emit("QueueUnPause", {
          extension: user.getExtension(),
          queue: queue
        });
      });
    },
    pause() {
      if (this.getPause == true) {
        if (this.interval_pause) {
          clearInterval(this.interval_pause);
          this.interval_pause = null;
        }
        if (this.audio_interval) {
          clearInterval(this.audio_interval);
          this.audio_interval = null;
        }

        this.isBlinking = false;
        this.redFlag = false;

        // Coleta todas as filas pausadas
        const pausedQueues = this.userQueues
          .filter(el => el.paused)
          .map(el => el.queue);

        if (pausedQueues.length > 0) {
          // Emit para o socket (ainda precisa ser individual por limitação do Asterisk)
          pausedQueues.forEach(queue => {
            connection.emit('QueueUnPause', {
              extension: user.getExtension(),
              queue: queue
            });
          });

          // Envia todas as filas de uma vez para a API
          const unpauseData = {
            tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
            queues: pausedQueues,
            userId: parseInt(this.getId),
          };
          this.sendOperatorUnpause(unpauseData);
        }
      }
      else {
        if (this.getDeslog == false) {
          this.setModalPause();
          this.fetchPauses();
        }
      }
    },
    agendamento() {
      this.setModalSchedule();
    },
    async deslogar() {
      console.log('[DEBUG LOGOUT] 1. Iniciando função deslogar. Telefone:', this.telefone);
      if (!this.telefone) return;

      const data = {
        queues: user.getQueue(),
        extension: user.getExtension(),
      };

      console.log('[DEBUG LOGOUT] 2. Dados mapeados:', data, '| getDeslog:', this.getDeslog);

      if (this.getDeslog) {
        console.log('[DEBUG LOGOUT] 3A. Entrou no if (this.getDeslog). Emitindo QueueAdd...');
        connection.emit("QueueAdd", data, (response) => {
          response.forEach(result => {
            if (result.status === 'success') {
              let find = this.userQueues.find(el => el.queue === result.queue)
              if (find) {
                find.logged = true
              }
              console.log(`[DEBUG LOGOUT] QueueAdd Sucesso na fila: ${result.queue}`);
            } else if (result.status === 'error') {
              console.error(`[DEBUG LOGOUT] QueueAdd Erro: ${result.message}`);
              console.error(`Detalhes: ${result.error}`);
            }
          });
        });
      } else {
        console.log('[DEBUG LOGOUT] 3B. Entrou no else (!this.getDeslog). Iniciando processo de logout...');
        if (user.getProfile() == 2) {
          if (!this.getMessages) this.setMessage();
        }

        try {
          // 1. Pergunta ao servidor se pode deslogar
          console.log('[DEBUG LOGOUT] 4. Disparando axios para validar logout...');
          const res = await axios.post("/dialer/logs", { type: "LOGOUT", checkOnly: true });
          const dataResp = res.data || {};
          console.log('[DEBUG LOGOUT] 5. Resposta do backend (checkOnly):', dataResp);

          // 2. Se o backend proibir o logout
          if (typeof dataResp.allowed !== "undefined" && dataResp.allowed === false) {
            console.warn('[DEBUG LOGOUT] 6. Backend bloqueou o logout. Exibindo SweetAlert e abortando.');
            Swal.fire({
              icon: 'warning',
              title: 'Logout não permitido',
              text: dataResp.message || 'Não foi possível realizar o logout. Contate a supervisão.',
              confirmButtonText: 'Entendi',
              confirmButtonColor: '#3085d6'
            });
            return; 
          }

          // 3. Verifica se o operador está pausado em alguma fila
          console.log('[DEBUG LOGOUT] 7. Analisando filas do usuário para ver se há pausas ativas...', this.userQueues);
          console.log('[DEBUG PAUSE] Snapshot this.userQueues antes de despausar:', JSON.parse(JSON.stringify(this.userQueues)));
          const localPausedQueues = this.userQueues
            .filter(el => el.paused)
            .map(el => el.queue);

          if (localPausedQueues.length > 0 && !connection?.connected) {
            console.error('[DEBUG PAUSE] Socket desconectado com pausa ativa. Logout bloqueado para evitar pausa presa.', {
              localPausedQueues
            });
            Swal.fire({
              icon: 'warning',
              title: 'Conexão de telefonia indisponível',
              text: 'Você está em pausa e a conexão com o servidor de telefonia caiu. Aguarde reconectar para despausar e só então deslogar.',
              confirmButtonText: 'Entendi',
              confirmButtonColor: '#f39c12'
            });
            return;
          }

          const statusPausedQueues = await this.getPausedQueuesFromStatus();
          const pausedQueues = [...new Set([...localPausedQueues, ...statusPausedQueues])];
          
          console.log('[DEBUG LOGOUT] 8. Filas identificadas como pausadas:', pausedQueues);
          console.log('[DEBUG PAUSE] Local paused queues:', localPausedQueues, '| Status paused queues:', statusPausedQueues);

          // 4. Se estiver pausado, tira a pausa e ESPERA terminar (await)
          if (pausedQueues.length > 0) {
            this.emitQueueUnpause(pausedQueues);
            await this.sleep(1200);
            const pausedAfterUnpauseEmit = await this.getPausedQueuesFromStatus();
            const stillPausedAfterEmit = pausedQueues.filter(queue => pausedAfterUnpauseEmit.includes(queue));
            console.log('[DEBUG PAUSE] Filas ainda pausadas após QueueUnPause:', stillPausedAfterEmit);
            if (stillPausedAfterEmit.length > 0) {
              console.warn('[DEBUG PAUSE] Asterisk ainda reporta pausa após QueueUnPause. Prosseguindo para API de retorno.', {
                stillPausedAfterEmit
              });
            }

            const unpauseData = {
              tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
              queues: pausedQueues,
              userId: parseInt(this.getId),
            };
            
            console.log('[DEBUG LOGOUT] 9. Vai disparar o sendOperatorUnpause com:', unpauseData);
            
            // O JS vai pausar a execução nesta linha até a pausa ser realmente removida
            const unpauseResponse = await this.sendOperatorUnpause(unpauseData);
            console.log('[DEBUG PAUSE] Resposta sendOperatorUnpause:', unpauseResponse);
            if (!unpauseResponse || !unpauseResponse.success) {
              throw new Error('Falha ao registrar retorno de pausa antes do logout');
            }
            
            console.log('[DEBUG LOGOUT] 10. sendOperatorUnpause finalizado com sucesso! (O await liberou)');
          } else {
            console.log('[DEBUG LOGOUT] 9. Nenhuma fila pausada encontrada. Pulando etapa de despausar.');
          }

          // 5. Só agora, com a permissão validada e a pausa removida, ele faz o logout das filas
          console.log('[DEBUG LOGOUT] 11. Disparando connection.emit("QueueRemove")...');
          connection.emit("QueueRemove", data, (response) => {
            console.log('[DEBUG LOGOUT] 12. Resposta do Socket QueueRemove:', response);
            response.forEach(result => {
              if (result.status === 'success') {
                let find = this.userQueues.find(el => el.queue === result.queue);
                if (find) {
                  find.logged = false;
                }
                console.log(`[DEBUG LOGOUT] QueueRemove Sucesso na fila: ${result.queue}`);
              } else if (result.status === 'error') {
                console.error(`[DEBUG LOGOUT] QueueRemove Erro: ${result.message}`);
                console.error(`Detalhes: ${result.error}`);
              }
            });
          });

        } catch (error) {
          // 6. Cai aqui se der algum erro
          console.error("[DEBUG LOGOUT] ERRO CRÍTICO no Catch:", error);

          Swal.fire({
            icon: 'error',
            title: 'Erro ao validar logout',
            text: 'Não foi possível validar o logout neste momento. Tente novamente em instantes ou contate a supervisão.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
          });
        }
      }
    },
    mute() {
      //HABILITANDO O MUTE APENAS SE ESTIVER EM LIGAÇÃO
      if (this.getChannel()) {
        this.setMute();

        //COLOCANDO NO LOCALSTORAGE PARA PEGAR INFORMAÇÃO DO MUTE QUANDO ATUALIZAR A PÁGINA
        this.getMute == true
          ? localStorage.setItem("mute", "true")
          : localStorage.removeItem("mute");

        //CONTROLANDO SE É PARA COLOCAR O MUTE OU PARA TIRAR E ENVIANDO EMIT NECESSÁRIO
        var stateMute = this.getMute == true ? "on" : "off";
        connection.emit("MuteAudio", {
          channel: this.getChannel(),
          extension: user.getExtension(),
          state: stateMute,
        });
      }
    },

    async hangup() {
      const channel = this.getChannel();

      if (!channel) return;

      connection.emit("hangup", {
        channel: channel,
      });

      await this.setChannel("");
      this.setCallTime("null");

      if (localStorage.getItem("mute")) {
        this.setMute();
        localStorage.removeItem("mute");
      }

      await clientData.mutations.delSpearheadData();
    },

    submitLogin(sub) {
      axios.post("/dialer/logs", { type: sub })
    },
    contacts() {
      if (!this.getContacts) {
        if (user.getProfile() == 2) {
          if (!this.getDeslog) this.setContacts();
        } else {
          this.setContacts();
        }
      }
    },
    operatorRealtime() {
      if (!this.getOperatorRealtime) {
        if (user.getProfile() == 2) {
          if (!this.getDeslog) this.setOperatorRealtime();
        } else {
          this.setOperatorRealtime();
        }
      }
    },
  },
  mounted() {
    this.fetchStoreQueues()
    this.checkTotalQUeues();
    this.totalMyQueue();

    // CAPTURANDO INFORMALÇÕES (SE ESTÁ EM LIGAÇÃO E SE ESTÁ LOGADO NA FILA)
    connection.emit("CoreShowChannels", {
      ramal: user.getExtension(),
    });

    // EVENTO PARA CAPTURAR DADOS DE LIGAÇÃO EM CURSO DO OPERADOR LOGADO
    connection.on(`CoreShowChannel-${user.getExtension()}`, async (data) => {
      //HABILITANDO CONTADOR E PASSANDO PRO CONTADOR QUANTO TEMPO ESTA EM LIGAÇÃO
      this.setCallTime(moment.duration(data.Duration).asSeconds());

      //BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
      var self = this;

      this.fetchClients(data.ConnectedLineNum).then(async function () {
        //Recupera os dados tratado
        let phoneSplit = data.ConnectedLineName.split("||");
        let dataPhone = phoneSplit[1];

        if (self.allClients && self.allClients.length > 0) {
          self.chooseClient(self.allClients[0]);
          self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
          self.setShowSpearhead();
          // self.clearAllClients();
        } else {
          //SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
          self.chooseClient({
            at_user_id: "",
            birthday: "",
            cep: "",
            city: "",
            complement: "",
            cpf: "",
            created_at: "",
            email: "",
            id: "",
            name: "",
            neighborhood: "",
            number: "",
            phone: dataPhone,
            phone_2: "",
            reference: "",
            rg: "",
            street: "",
            updated_at: "",
          });
          self.setShowSpearhead();
        }
      });
      this.fetchProtocol();
      //SETANDO O CANAL DA LIGAÇÃO ATUAL
      this.setChannel(data.Channel);

      const validContexts = [
        'macro-arguments-sgg-help-desk',
        'macro-arguments-sgg-noc',
        'macro-arguments-ana',
        'macro-arguments-mre',
        'macro-arguments-tre-ce'
      ];

      if (data.Context === 'macro-arguments') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'queueIncoming');
      }
      if (validContexts.includes(data.Context)) {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'queueIncomingNew');
      } else if (data.Context === 'macro-connect-line-externo') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'outgoing');
      } else if (data.Context === 'macro-transfer-blind') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'blindTransfer');
      }
      //HABILITANDO O MUTE NOVAMENTE CASO SEJA ATUALIZADO A PÁGINA
      localStorage.getItem("mute") && this.getChannel() && this.getMute == false
        ? this.setMute()
        : false;
    });

    // EVENT NECESSÁRIO PARA HABILITAR OS BOTÕES (LOGADO E PAUSA) QUANDO APESSOA ENTRA NA PAGINA
    connection.emit("QueueStatus", { ramal: user.getExtension() }, (queues) => {
      const now = Math.floor(Date.now() / 1000);
      const pausedQueue = queues.find(q => q.Paused == 1);
      if (pausedQueue) {
        const pauseSeconds = now - pausedQueue.LastPause;
        this.setPauseTime(pauseSeconds);
      }
    });

    // HABILITANDO OS BOTÕES NOVAMENTE CASO ESTEJA LOGADO... EM PAUSA...
    connection.on(`QueueMember-${user.getExtension()}`, async (data) => {
      const queuename = (data.Queue || '').toLowerCase();

      let find = this.userQueues.find(el =>
          (el.queue || '').toLowerCase() === queuename
      );
      const isPaused = parseInt(data.Paused, 10) === 1;

      console.log('[DEBUG QUEUE MEMBER] Evento recebido:', data);

      if (find) {
        find.logged = true;
        find.paused = isPaused;
      }

      if (this.userQueues.some(el => el.logged) && this.getDeslog) {
        this.setDeslog();
      }

      if (isPaused) {
        const now = Math.floor(Date.now() / 1000);
        const lastPause = Number(data.LastPause || now);
        const pauseSeconds = Math.max(0, now - lastPause);

        this.setPauseTime(pauseSeconds);

        this.selectPause({
          pauseId: data.PausedReason || '',
          tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
          queue: queuename,
          userId: parseInt(this.getId)
        });
      }

      console.log(
        '[DEBUG QUEUE MEMBER] Estado atualizado:',
        JSON.parse(JSON.stringify(this.userQueues))
      );
    });

    // VALIDANDO QUANDO USUÁRIO É INSERIDO NA FILA
    connection.on(`QueueMemberAdded-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if (find) find.logged = true

      if (this.getDeslog) {
        this.setDeslog();
        this.startOrOut();
        this.submitLogin("LOGIN");
      }
    });

    // VALIDANDO QUANDO USUÁRIO É EXPULSO DA FILA
    connection.on(`QueueMemberRemoved-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if (find) {
        find.logged = false
        find.paused = false
      }

      if (!this.userQueues.some(el => el.logged)) {
        if (this.getPause == true) {
          this.userQueues.forEach(el => {
            if (el.paused) {
              connection.emit('QueueUnPause', {
                extension: user.getExtension(),
                queue: el.queue
              });
            }
            // Limpar estado de pausa de todas as filas
            el.paused = false
          })

          const time = this.getTime();
          this.comeBack(time);
        }

        // Limpar timers e flags visuais
        this.setPauseTime("null");
        this.isBlinking = false;
        this.redFlag = false;
        this.time_pause = 0;
        this.time_pause_format = "00:00:00";

        if (this.interval_pause) {
          clearInterval(this.interval_pause);
          this.interval_pause = null;
        }
        if (this.audio_interval) {
          clearInterval(this.audio_interval);
          this.audio_interval = null;
        }

        if (!this.getDeslog) this.setDeslog();
        this.startOrOut();
        this.submitLogin("LOGOUT");
      }
    });

    // PEGANDO CANAL DO USUÁRIO EM LIGAÇÃO
    connection.on(`NewConnectedLine-${user.getExtension()}`, async (data) => {
      console.log("New-Connect", data)
      this.chooseClientPhone("");
      if (data.ChannelStateDesc !== 'Up') return;
      const validContexts = [
        'macro-arguments-sgg-help-desk',
        'macro-arguments-sgg-noc',
        'macro-arguments-ana',
        'macro-arguments-mre',
        'macro-arguments-tre-ce'
      ];

      if (data.Context === 'macro-arguments') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'queueIncoming');
      }
      if (validContexts.includes(data.Context)) {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'queueIncomingNew');
      } else if (data.Context === 'macro-arguments-crv') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'incomingCrv');
      } else if (data.Context === 'macro-connect-line-externo') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'outgoing');
      } else if (data.Context === 'macro-transfer-blind') {
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'blindTransfer');
      }

      //Recupera os dados tratado
      let phoneSplit = data.ConnectedLineName.split("||");
      let dataPhone = phoneSplit[1];

      //INICIANDO O CONTADOR COM ZERO
      this.setCallTime(1);

      //BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
      var self = this;
      this.fetchClients(dataPhone).then(function () {
        if (self.allClients && self.allClients.length > 0) {
          self.chooseClient(self.allClients[0]);
          self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
          self.setShowSpearhead();
          self.clearAllClients();
        } else {
          //SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
          self.chooseClient({
            at_user_id: "",
            birthday: "",
            cep: "",
            city: "",
            complement: "",
            cpf: "",
            created_at: "",
            email: "",
            id: "",
            name: "",
            neighborhood: "",
            number: "",
            phone: dataPhone,
            phone_2: "",
            reference: "",
            rg: "",
            street: "",
            updated_at: "",
          });
          self.setShowSpearhead();
        }
      });
      this.fetchProtocol();

      //SETANDO CANAL NO STATE
      this.setChannel(data.Channel);
    });

    // DESABILITANDO BOTÃO DE MUTE QUANDO FINALIZADO A LIGAÇÃO
    connection.on(`Hangup-${user.getExtension()}`, async (data) => {
      await this.setChannel("");
      this.setCallTime("null");

      if (localStorage.getItem("mute")) {
        this.setMute();
        localStorage.removeItem("mute");
      }

      //CADASTRANDO A LIGAÇÃO REALIZADA DO CLIENTE
      var structClient = {
        at_user_id: this.getId,
        ticket: this.getProtocol.protocol,
        uniqueid: data.Linkedid,
        type: "telefonia",
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      structClient.cpf_cnpj = this.oneClient ? this.oneClient.cpf_cnpj : null;
      this.saveClient(structClient);
      this.setCallTime("null");
      this.clearClient();
      this.clearAllClients();
      this.setChannel("");

      //LIMPANDO O CAMPO DE PRODUTO
      $(".select2-multi").val("-1").trigger("change");

      //Limpa o ponta de lanca
      await clientData.mutations.delSpearheadData();
    });

    connection.on(`QueueMemberPause-${user.getExtension()}`, (data) => {
      const queuename = (data.Queue || '').toLowerCase();

      let find = this.userQueues.find(el =>
          (el.queue || '').toLowerCase() === queuename
      );
      const isPaused = parseInt(data.Paused, 10) === 1;
      const time = this.getTime();

      console.log('[DEBUG PAUSE EVENT] Evento recebido:', data);
      console.log('[DEBUG PAUSE EVENT] Fila encontrada:', find);

      if (find) {
        find.paused = isPaused;
      }

      if (isPaused) {
        this.setPauseTime(0);

        this.selectPause({
          pauseId: data.PausedReason || '',
          tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
          queue: queuename,
          userId: parseInt(this.getId)
        });
      }

      const possuiFilaPausada = this.userQueues.some(el => el.paused);

      if (!possuiFilaPausada) {
        if (this.interval_pause) {
          clearInterval(this.interval_pause);
          this.interval_pause = null;
        }

        if (this.audio_interval) {
          clearInterval(this.audio_interval);
          this.audio_interval = null;
        }

        this.setPauseTime("null");
        this.comeBack(time);

        this.isBlinking = false;
        this.redFlag = false;
        this.time_pause = 0;
        this.time_pause_format = "00:00:00";
      }

      console.log(
        '[DEBUG PAUSE EVENT] Estado final das filas:',
        JSON.parse(JSON.stringify(this.userQueues))
      );
    });
  },
};
</script>

<style scoped>
.blink-red {
  animation: blink-red 1s infinite;
}

@keyframes blink-red {
  0% {
    background-color: red;
  }

  50% {
    background-color: transparent;
  }

  100% {
    background-color: red;
  }
}

.num {
  width: 25px;
  height: 25px;
  text-align: center;
  text-combine-upright: all;
  left: 4em;
  border-radius: 50%;
  line-height: 25px;
  color: white;
  background-color: red;
  top: 5.5em;
  position: absolute;
}

.barra-lateral-esquerdo {
  background-color: #cccccc;
  width: 100%;
  max-width: 99px;
  text-align: center;
  border-right: solid 1px #1c869a;
  min-height: 100%;
  height: calc(100vh - 4.5em);
  overflow: auto;
}

::-webkit-scrollbar {
  width: 0.18rem;
}

::-webkit-scrollbar-track {
  background: #f38630;
}

::-webkit-scrollbar-thumb {
  background: #1c869a;
}

.figure-image {
  margin: 0px;
  display: block;
}

.figure-image div {
  margin: 0px;
  padding: 9px 0 9px 0;
}

.figure-image figcaption {
  color: white;
}

.backGroundOrangeRed {
  background-color: orangered;
}

.backGroundOrange {
  background-color: #fea33b;
}

.bg-adv {
  background: #1c869a;
}

.backgroundGreen {
  background: #27ae60;
}

.count-msg {
  padding: 0px;
  color: white;
  font-size: 1.5em;
}

strong .count-msg {
  font-size: 1.5em;
}

.remove-padding {
  padding: 0 !important;
}
</style>